/* KAARKASH homepage — reveal-on-scroll, product slider, quick add.
   Loaded by each editorial section, so everything here is idempotent. */
(function () {
  'use strict';
  if (window.__kkHome) { window.__kkHome.scan(); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- reveal ----------
     A section reveals once a set depth of it is on screen: 200px for the big image sections,
     60px for the sliders (data-kk-at). Fired any earlier, the movement is over before the
     visitor has scrolled far enough to see it. */
  var observers = {};
  var SLOW_PHOTO = 3000;
  function ready(pane) { pane.classList.add('is-ready'); }
  // A photograph plays its entrance only once its file is there.
  function prime(el) {
    el.querySelectorAll('[data-kk-image]').forEach(function (pane) {
      var img = pane.querySelector('img');
      if (!img || (img.complete && img.naturalWidth)) { ready(pane); return; }
      img.addEventListener('load', function () { ready(pane); }, { once: true });
      img.addEventListener('error', function () { ready(pane); }, { once: true });
    });
  }
  function reveal(el) {
    el.classList.add('is-in');
    // slow or lost, a photograph must not leave its frame empty for good
    setTimeout(function () { el.querySelectorAll('[data-kk-image]:not(.is-ready)').forEach(ready); }, SLOW_PHOTO);
  }
  function depth(el) {
    var want = parseInt(el.getAttribute('data-kk-at'), 10);
    if (!(want >= 0)) want = 60;
    if (want > 100 && window.innerHeight < 700) want = 100;   // a short screen shows less of a section at a time
    // a short window, or a short section, must still be able to reach its mark
    var height = el.getBoundingClientRect().height || want;
    return Math.max(0, Math.round(Math.min(want, window.innerHeight * 0.3, height * 0.5) / 20) * 20);
  }
  function observerAt(px) {
    if (!observers[px]) {
      observers[px] = new IntersectionObserver(function (entries, self) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          reveal(e.target);
          self.unobserve(e.target);
          e.target.__kkObserver = null;
        });
      }, { rootMargin: '0px 0px -' + px + 'px 0px', threshold: 0 });
    }
    return observers[px];
  }
  function observe(el) {
    if (el.__kkObserver) el.__kkObserver.unobserve(el);
    el.__kkObserver = observerAt(depth(el));
    el.__kkObserver.observe(el);
  }
  function watch(el) {
    if (el.__kkWatched) return;
    el.__kkWatched = true;
    prime(el);
    if (designMode || !('IntersectionObserver' in window)) { reveal(el); return; }
    observe(el);
  }
  // The depth is read from the window and the section as they were: a turned phone or a
  // resized window gets a fresh one for every section still waiting.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (designMode || !('IntersectionObserver' in window)) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.kkm:not(.is-in)').forEach(function (el) { if (el.__kkWatched) observe(el); });
    }, 200);
  });

  /* ---------- slider ---------- */
  var SETTLE_MS = 1500;   // how long after the page has loaded a row is still held at its start
  function initSlider(root) {
    if (root.__kkSlider) return;
    root.__kkSlider = true;
    var track = root.querySelector('[data-kks-track]');
    var prev = root.querySelector('[data-kks-prev]');
    var next = root.querySelector('[data-kks-next]');
    if (!track) return;

    // Every row opens on its first card. Safari re-snapped a snapping row to a card of its own
    // choosing as the page's styles landed (measured on an iPhone: the home page's rows opened
    // on their 2nd to 7th card, with no script moving them). So a row snaps only once the
    // shopper moves it (is-live, assets/kk-home.css), and while the page settles it is held at
    // its start. Only while it settles: after that a scroll no hand made (the browser's find
    // in page going to a piece) is left where it goes.
    var touched = false;
    var settling = true;
    function live() {
      if (touched) return;
      touched = true;
      track.classList.add('is-live');
    }
    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(function (type) {
      track.addEventListener(type, live, { passive: true });
    });
    [prev, next].forEach(function (b) { if (b) b.addEventListener('click', live); });
    function settled() { setTimeout(function () { settling = false; }, SETTLE_MS); }
    if (document.readyState === 'complete') settled();
    else window.addEventListener('load', settled, { once: true });
    track.addEventListener('scroll', function () {
      if (settling && !touched && track.scrollLeft > 0) track.scrollLeft = 0;
    }, { passive: true });
    if (track.scrollLeft > 0) track.scrollLeft = 0;

    function step() {
      var card = track.querySelector('.kks__card');
      if (!card) return track.clientWidth;
      var w = card.getBoundingClientRect().width;
      var visible = Math.max(1, Math.floor(track.clientWidth / w));
      return w * Math.max(1, visible - (visible > 2 ? 1 : 0));
    }
    function sync() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    // WebKit refuses a programmatic smooth scroll on a snapping container, so the snap is
    // lifted for the length of the glide and handed back once it lands.
    var snapTimer = null;
    function glide(dir) {
      var to = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + dir * step()));
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: to, behavior: reduce ? 'auto' : 'smooth' });
      clearTimeout(snapTimer);
      snapTimer = setTimeout(function () { track.style.scrollSnapType = ''; sync(); }, reduce ? 0 : 700);
    }
    if (prev) prev.addEventListener('click', function () { glide(-1); });
    if (next) next.addEventListener('click', function () { glide(1); });

    /* Photographs are fetched as they are wanted: those of cards near the visible part of the
       slider, once the slider is near the screen. Cards further along wait until the slider
       is scrolled towards them; the second photograph of a card waits for a pointer that can
       hover (a phone never shows it). */
    var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    var pageLoaded = document.readyState === 'complete';
    // A photograph is marked ready once its file is here (or has failed: the shimmer must not
    // run for ever). The first: the frame stops shimmering and the photograph fades in. The
    // second: it may now come up on hover, and the card stops waiting for it.
    function ready(img) {
      if (!img || img.__kkReady) return;
      function mark(e) {
        img.__kkReady = true;
        var failed = !!(e && e.type === 'error');
        // a second photograph that failed is never brought up: hovering keeps the first
        if (!failed || img.classList.contains('kks__img--main')) img.classList.add('is-ready');
        var card = img.closest('.kks__card');
        if (img.classList.contains('kks__img--main')) {
          var media = img.closest('.kks__media');
          if (media) media.classList.add('is-ready');
          if (fine && pageLoaded && card) idle(function () { load(card.querySelector('.kks__img--hover')); });
        } else if (card) card.classList.remove('is-waiting');
      }
      if (img.getAttribute('src') && img.complete) { mark(img.naturalWidth ? null : { type: 'error' }); return; }
      img.addEventListener('load', mark, { once: true });
      img.addEventListener('error', mark, { once: true });
    }
    function load(img) {
      if (!img || !img.hasAttribute('data-src')) return;
      if (img.hasAttribute('data-srcset')) { img.srcset = img.getAttribute('data-srcset'); img.removeAttribute('data-srcset'); }
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      ready(img);
    }
    track.querySelectorAll('.kks__img--main').forEach(function (img) { if (img.getAttribute('src')) ready(img); });
    function fetchNear() {
      var r = root.getBoundingClientRect();
      if (r.top > window.innerHeight + 300 || r.bottom < -300) return;          // the slider itself is far off
      var t = track.getBoundingClientRect(), reach = t.width * 0.75;
      track.querySelectorAll('.kks__img--main[data-src]').forEach(function (img) {
        var c = img.getBoundingClientRect();
        if (c.right > t.left - reach && c.left < t.right + reach) load(img);
      });
    }
    var fetchFrame = 0;
    function fetchSoon() { if (!fetchFrame) fetchFrame = requestAnimationFrame(function () { fetchFrame = 0; fetchNear(); }); }
    track.addEventListener('scroll', fetchSoon, { passive: true });
    window.addEventListener('scroll', fetchSoon, { passive: true });
    window.addEventListener('resize', fetchSoon);
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) { if (entries.some(function (e) { return e.isIntersecting; })) fetchSoon(); }, { rootMargin: '300px 0px' });
      seen.observe(root);
    }
    fetchNear();
    var conn = navigator.connection || {};
    if (fine && !conn.saveData && !/2g/.test(conn.effectiveType || '')) {
      // Under a pointer that can hover (and not on a line the visitor is saving), the second photographs of the cards already shown are
      // fetched once the page has finished loading and the browser is idle, so a hover rarely
      // has to wait. When it does, the card waits with a gleam over its first photograph.
      var warm = function () {
        pageLoaded = true;
        idle(function () { track.querySelectorAll('.kks__media.is-ready .kks__img--hover[data-src]').forEach(load); }, { timeout: 3000 });
      };
      if (pageLoaded) warm(); else window.addEventListener('load', warm, { once: true });
      track.addEventListener('mouseover', function (e) {
        var card = e.target.closest && e.target.closest('.kks__card');
        var hover = card && card.querySelector('.kks__img--hover');
        if (!hover) return;
        load(hover);
        if (!hover.classList.contains('is-ready')) card.classList.add('is-waiting');
      });
      track.addEventListener('mouseout', function (e) {
        var card = e.target.closest && e.target.closest('.kks__card');
        if (card && !card.contains(e.relatedTarget)) card.classList.remove('is-waiting');
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();

    // Drag to scroll with a mouse. Touch keeps the browser's own momentum scrolling.
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('.kks__add')) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) { moved = true; track.classList.add('is-dragging'); }
      track.scrollLeft = startLeft - dx;
    });
    function release() {
      if (!down) return;
      down = false;
      if (moved) setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- cart ---------- */
  function addToCart(variantId) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-icon-bubble'];
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { var err = new Error(res.body && (res.body.description || res.body.message) || 'add_failed'); err.kk = true; throw err; }
        // quietly: the piece is in the cart, but the visitor has moved on to something else,
        // so the cart is brought up to date where it sits and nothing opens over what they are doing
        return function openCart(quietly) {
          var sections = res.body.sections;
          if (quietly) {
            if (!drawer || !drawer.getSectionInnerHTML || !sections) return;
            drawer.classList.remove('is-empty');
            drawer.getSectionsToRender().forEach(function (part) {
              var el = part.selector ? document.querySelector(part.selector) : document.getElementById(part.id);
              if (el && sections[part.id]) el.innerHTML = drawer.getSectionInnerHTML(sections[part.id], part.selector);
            });
            var overlay = drawer.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
            return;
          }
          if (drawer && drawer.renderContents && sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.body);
          } else window.location.href = ROOT + 'cart';
        };
      });
  }

  /* ---------- quick-add sheet ----------
     Title and price, every product photograph in a swipeable strip at its true shape,
     the options, then Add to cart / Buy now. */
  var sheet = null, lastFocus = null, current = null, cache = {}, thumb = null, opened = 0;
  // Buy now mirrors the product page: India only, straight to the standard checkout.
  var BUY_NOW = !!(window.Shopify && Shopify.country === 'IN');

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(whole ? 0 : 2) + ' ' + cur; }
  }
  function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function fileName(src) { return String(src || '').split('?')[0].split('/').pop(); }
  // The photograph already on the card stands in for the first slide until the sharp one lands.
  function cardPhoto(opener) {
    var card = opener && opener.closest && opener.closest('.kks__card, [data-kk-card]');
    var img = card && card.querySelector('img');
    if (!img || !img.complete || !img.naturalWidth || img.hasAttribute('data-src')) return null;   // (still a blank stand-in: kk-page.js)
    return { src: img.currentSrc || img.src, ratio: Math.min(1.6, Math.max(0.5, img.naturalWidth / img.naturalHeight)) };
  }
  function standIn(slide) {
    if (slide && thumb) slide.style.backgroundImage = 'url("' + thumb.src.replace(/"/g, '%22') + '")';
  }
  function q(sel) { return sheet.querySelector(sel); }

  // Drag to scroll with a mouse; touch keeps the browser's own momentum.
  function dragScroll(track) {
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) {
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) { /* capture is a nicety, the drag works without it */ }
      }
      track.scrollLeft = startLeft - dx;
    });
    function release() { down = false; if (moved) { moved = false; track.classList.remove('is-dragging'); } }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('pointerleave', function (e) { if (!track.hasPointerCapture || !track.hasPointerCapture(e.pointerId)) release(); });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  // A button's face: its label, the line that sweeps while it works, the tick once it is done.
  function face(label) {
    return '<span class="kkq__btn-text" data-kkq-label>' + esc(label) + '</span>' +
      '<span class="kkq__btn-load" aria-hidden="true"><i></i></span>' +
      '<svg class="kkq__btn-tick" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m1.88 11.988 6.21 6.103L22.467 3.83" pathLength="1" stroke="currentColor" stroke-width="3"/></svg>';
  }
  function label(btn, text) {
    btn.classList.remove('is-loading', 'is-done');
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('aria-label');
    btn.querySelector('[data-kkq-label]').textContent = text;
  }

  // The + turns into a tick once the piece is in the cart, then settles back.
  var TICK_DRAW = 600, TICK_HOLD = 2400;
  function markAdded(plus) {
    if (!plus || !plus.classList || !plus.classList.contains('kks__add')) return;
    // its own label is kept once, so marking it again mid-hold cannot lose it
    if (plus.__kkLabel == null) plus.__kkLabel = plus.getAttribute('aria-label') || '';
    plus.classList.remove('is-busy');
    plus.classList.add('is-done');
    plus.setAttribute('aria-label', 'Added to cart');
    clearTimeout(plus.__kkDone);
    plus.__kkDone = setTimeout(function () {
      plus.classList.remove('is-done');
      if (plus.__kkLabel) plus.setAttribute('aria-label', plus.__kkLabel);
      else plus.removeAttribute('aria-label');
    }, TICK_HOLD);
  }

  /* ---------- into the bag ----------
     A piece added from a card is seen to go there: a copy of the card's photograph lifts off
     and arcs into the bag in the header, shrinking as it goes, and the bag gives a small
     bounce as it lands. Then the cart opens. Two layers make the arc: the outer one travels
     across, the inner one up, each on its own curve. Nothing flies for reduced motion. */
  var FLY = 720;
  function shotOf(plus) {
    var card = plus && plus.closest && plus.closest('.kks__card, [data-kk-card]');
    var media = card && card.querySelector('.kks__media, .kkc-card__media');
    if (!media) return null;
    var box = media.getBoundingClientRect();
    if (!box.width || box.bottom < 0 || box.top > window.innerHeight) return null;
    // the photograph showing now: the topmost one (last in the frame) that is drawn and whose
    // middle is inside the frame — the second photograph while it is up on hover
    var pick = null, imgs = media.querySelectorAll('img');
    for (var i = imgs.length - 1; i >= 0 && !pick; i--) {
      var im = imgs[i], src = im.currentSrc || im.getAttribute('src') || '';
      if (!src || src.indexOf('data:') === 0 || !im.complete || !im.naturalWidth || parseFloat(getComputedStyle(im).opacity) < .5) continue;
      var r = im.getBoundingClientRect(), mid = r.left + r.width / 2;
      if (mid >= box.left && mid <= box.right) pick = src;
    }
    return pick ? { src: pick, media: media } : null;
  }
  function bagSpot() {
    var bag = document.getElementById('cart-icon-bubble');
    var r = bag && bag.getBoundingClientRect();
    if (r && r.width && r.bottom > 0 && r.top < window.innerHeight) return { x: r.left + r.width / 2, y: r.top + r.height / 2, bag: bag };
    return { x: window.innerWidth - 28, y: 28, bag: null };   // the header is tucked away: aim for its corner
  }
  function bounce(bag) {
    if (bag && bag.animate && !reduce) bag.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.33, 0, 0, 1)' });
  }
  // Never rejects: whatever happens to the flight, the cart still opens. With nothing to fly
  // (reduced motion, the card off screen), it waits as long as the cart always waited.
  function flyToBag(plus, pause) {
    var wait = function () { return new Promise(function (r) { setTimeout(r, reduce ? 0 : pause || 0); }); };
    try {
      var shot = reduce ? null : shotOf(plus);
      if (!shot || !document.body.animate) return wait();
      // the copy is drawn from the photograph already on screen (so from the browser's cache);
      // it waits at most a moment to be ready, so it never lifts off as an empty box
      var pic = new Image();
      pic.src = shot.src;
      var ready = pic.decode ? pic.decode().catch(function () {}) : Promise.resolve();
      return Promise.race([ready, new Promise(function (r) { setTimeout(r, 150); })])
        .then(function () { return fly(shot); })
        .catch(function () {});
    } catch (e) { return wait(); }
  }
  function fly(shot) {
    return new Promise(function (done) {
      var to = bagSpot(), b = shot.media.getBoundingClientRect();   // where the card is now
      var finished = false, outer = null;
      function land() {
        if (finished) return;
        finished = true;
        if (outer) outer.remove();
        bounce(to.bag);
        done();
      }
      setTimeout(land, FLY + 300);                        // whatever happens, it lands
      if (!b.width || b.bottom < 0 || b.top > window.innerHeight) { land(); return; }   // scrolled away meanwhile
      var dx = to.x - (b.left + b.width / 2), dy = to.y - (b.top + b.height / 2);
      outer = document.createElement('span');
      outer.className = 'kk-fly';
      outer.setAttribute('aria-hidden', 'true');
      outer.style.cssText = 'left:' + b.left + 'px;top:' + b.top + 'px;width:' + b.width + 'px;height:' + b.height + 'px;';
      var inner = document.createElement('span');
      inner.className = 'kk-fly__shot';
      inner.style.backgroundImage = 'url("' + shot.src.replace(/"/g, '%22') + '")';
      outer.appendChild(inner);
      document.body.appendChild(outer);
      var s = 22 / b.width, flight;
      try {
        outer.animate([{ transform: 'translate3d(0, 0, 0)' }, { transform: 'translate3d(' + dx + 'px, 0, 0)' }], { duration: FLY, easing: 'cubic-bezier(.3, 0, .6, 1)', fill: 'forwards' });
        flight = inner.animate([
          { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1, borderRadius: '0px' },
          { transform: 'translate3d(0, -18px, 0) scale(.9)', opacity: 1, offset: .16 },
          { transform: 'translate3d(0, ' + dy + 'px, 0) scale(' + s + ')', opacity: .85, borderRadius: (b.width / 2) + 'px' }
        ], { duration: FLY, easing: 'cubic-bezier(.5, 0, .75, .4)', fill: 'forwards' });
      } catch (e) { land(); return; }
      flight.onfinish = land;
    });
  }

  function buildSheet(url) {
    sheet = document.createElement('div');
    sheet.className = 'kkq';
    sheet.innerHTML =
      '<span class="kkq__wash" data-kkq-close></span>' +
      '<div class="kkq__panel" role="dialog" aria-modal="true" aria-labelledby="kkq-title" tabindex="-1">' +
        '<button type="button" class="kkq__close" data-kkq-close aria-label="Close">' +
          '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M2 2l14 14M16 2L2 16"/></svg>' +
        '</button>' +
        '<div class="kkq__body">' +
          '<div class="kkq__head"><h3 class="kkq__title" id="kkq-title" data-kkq-title>&nbsp;</h3>' +
            '<div class="kkq__meta"><p class="kkq__price" data-kkq-price>&nbsp;</p><a class="kkq__details" data-kkq-details href="' + esc(url) + '">View details</a></div></div>' +
          '<div class="kkq__gallery" data-kkq-gallery><ul class="kkq__track" role="list"><li class="kkq__slide" style="--r: ' + (thumb ? thumb.ratio.toFixed(4) : '.75') + '"></li><li class="kkq__slide" style="--r: .75"></li></ul></div>' +
          '<div class="kkq__form"><span data-kkq-options></span><p class="kkq__note" data-kkq-note aria-live="polite"></p>' +
            '<p class="kkq__trust">Free shipping <i>·</i> Cash on delivery <i>·</i> Easy exchange</p></div>' +
        '</div>' +
        '<div class="kkq__actions">' +
          '<button type="button" class="kkq__btn" data-kkq-add disabled>' + face('Add to cart') + '</button>' +
          (BUY_NOW ? '<button type="button" class="kkq__btn" data-kkq-buy data-cf-skip disabled>' + face('Buy now') + '</button>' : '') +
        '</div>' +
      '</div>';
    document.body.appendChild(sheet);
    standIn(sheet.querySelector('.kkq__slide'));
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-kkq-close]')) { closeSheet(); return; }
      var val = e.target.closest('[data-kkq-value]');
      if (val) { choose(Number(val.getAttribute('data-kkq-opt')), val.getAttribute('data-kkq-value')); return; }
      if (e.target.closest('[data-kkq-add]')) { submit(false); return; }
      if (e.target.closest('[data-kkq-buy]')) submit(true);
    });
  }
  // Keys are heard on the document, not the sheet: a button that goes disabled under the
  // finger drops focus to the page, and Escape and Tab must still belong to the open sheet.
  document.addEventListener('keydown', function (e) {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = sheet.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], at = document.activeElement;
    if (!sheet.contains(at)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && at === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
  });
  // Back from checkout (bfcache): never come back to a locked, half-submitted sheet.
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeSheet(true); });
  window.addEventListener('resize', function () { if (sheet && sheet.classList.contains('is-open')) fit(); });

  // Two photographs can be narrower than the sheet: let them grow a little to fill it, and
  // centre whatever still falls short, rather than leave a blank band on the right.
  function fit() {
    var track = current && current.track;
    if (!track) return;
    sheet.style.removeProperty('--kkq-h');
    var base = track.clientHeight, width = track.clientWidth, sum = 0;
    var slides = track.querySelectorAll('.kkq__slide');
    slides.forEach(function (li) { sum += parseFloat(li.style.getPropertyValue('--r')) || 0.75; });
    var gaps = Math.max(0, slides.length - 1) * 2;
    if (!sum || sum * base + gaps >= width) { track.classList.remove('is-short'); return; }
    var h = Math.min((width - gaps) / sum, base * 1.15);
    sheet.style.setProperty('--kkq-h', h.toFixed(1) + 'px');
    track.classList.toggle('is-short', sum * h + gaps < width - 1);
    if (current.sync) current.sync();
  }

  function photos(p) {
    var list = (p.media || []).filter(function (m) { return m.media_type === 'image' && m.src; }).map(function (m) {
      var r = m.aspect_ratio || (m.width && m.height ? m.width / m.height : 0.75);
      return { id: m.id, src: m.src, ratio: Math.min(1.6, Math.max(0.5, r)), alt: m.alt || p.title };
    });
    if (!list.length) list = (p.images || []).map(function (src) { return { id: null, src: src, ratio: 0.75, alt: p.title }; });
    return list.slice(0, 12);
  }

  function variantFor(sel) {
    return current.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  }
  // A value is "out" when no in-stock variant carries it together with the other choices.
  function valueAvailable(optIndex, value) {
    return current.product.variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      return v.options.every(function (o, i) { return i === optIndex || o === current.sel[i]; });
    });
  }

  function paintHead() {
    q('[data-kkq-title]').textContent = current.product.title.split('|')[0].trim();
  }

  function paintGallery() {
    var list = photos(current.product);
    var box = q('[data-kkq-gallery]');
    if (!list.length) { box.innerHTML = ''; box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML =
      '<ul class="kkq__track" data-kkq-track tabindex="0" role="list" aria-label="Product photos, ' + list.length + '">' +
      list.map(function (m, i) {
        return '<li class="kkq__slide" data-kkq-media="' + esc(m.id == null ? '' : m.id) + '" data-kkq-src="' + esc(fileName(m.src)) + '" style="--r: ' + m.ratio.toFixed(4) + '">' +
          '<img src="' + esc(sized(m.src, 600)) + '" srcset="' + esc(sized(m.src, 400)) + ' 400w, ' + esc(sized(m.src, 600)) + ' 600w, ' + esc(sized(m.src, 900)) + ' 900w, ' + esc(sized(m.src, 1200)) + ' 1200w" sizes="(min-width: 750px) ' + Math.round(440 * m.ratio) + 'px, ' + Math.round(270 * m.ratio) + 'px" alt="' + esc(m.alt) + '" decoding="async" loading="' + (i < 3 ? 'eager' : 'lazy') + '" draggable="false"></li>';
      }).join('') + '</ul>' +
      (list.length > 1 ? '<div class="kkq__bar" aria-hidden="true"><span data-kkq-thumb></span></div>' : '');
    var track = box.querySelector('[data-kkq-track]');
    var bar = box.querySelector('[data-kkq-thumb]');
    if (thumb && fileName(thumb.src) === fileName(list[0].src)) standIn(track.querySelector('.kkq__slide'));
    box.querySelectorAll('img').forEach(function (img) {
      function shown() { img.classList.add('is-in'); }
      if (img.complete && img.naturalWidth) { shown(); return; }
      img.addEventListener('load', shown);
      // a photograph that will not load leaves no hole in the strip
      img.addEventListener('error', function () { var li = img.closest('li'); if (li) li.remove(); fit(); sync(); });
    });
    var ticking = false;
    function sync() {
      if (!bar) return;
      var ratio = track.clientWidth / Math.max(1, track.scrollWidth);
      if (ratio >= 0.999) { bar.parentNode.hidden = true; return; }
      bar.parentNode.hidden = false;
      bar.style.width = (ratio * 100) + '%';
      bar.style.transform = 'translate3d(' + (track.scrollLeft / Math.max(1, track.clientWidth) * 100) + '%, 0, 0)';
    }
    track.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; sync(); }); }, { passive: true });
    dragScroll(track);
    current.track = track;
    current.sync = sync;
    fit();
    sync();
  }

  function showVariantPhoto(v) {
    var track = current && current.track;
    if (!track || !v) return;
    var slide = null;
    if (v.featured_media && v.featured_media.id != null) slide = track.querySelector('[data-kkq-media="' + v.featured_media.id + '"]');
    if (!slide && v.featured_image && v.featured_image.src) {
      var name = fileName(v.featured_image.src);
      track.querySelectorAll('.kkq__slide').forEach(function (li) { if (!slide && li.getAttribute('data-kkq-src') === name) slide = li; });
    }
    if (!slide) return;
    var to = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, slide.offsetLeft));
    track.style.scrollSnapType = 'none';
    track.scrollTo({ left: to, behavior: reduce ? 'auto' : 'smooth' });
    clearTimeout(track.__kkSnap);
    track.__kkSnap = setTimeout(function () { track.style.scrollSnapType = ''; }, reduce ? 0 : 700);
  }

  function paintForm() {
    var p = current.product, v = variantFor(current.sel);
    var price = v ? v.price : p.price, was = v ? v.compare_at_price : p.compare_at_price;
    var sale = was && was > price;
    q('[data-kkq-price]').innerHTML = '<span class="' + (sale ? 'is-sale' : '') + '">' + esc(money(price)) + '</span>' +
      (sale ? '<s>' + esc(money(was)) + '</s><em class="kkq__save">Save ' + Math.round((was - price) / was * 100) + '%</em>' : '');
    var single = p.variants.length === 1 && p.variants[0].title === 'Default Title';
    var html = '', fixed = '';
    if (!single) {
      p.options.forEach(function (opt, i) {
        // nothing to choose: say it in a line instead of offering a one-button choice
        if (opt.values.length < 2) { fixed += '<span>' + esc(opt.name) + ' <b>' + esc(opt.values[0] || '') + '</b></span>'; return; }
        html += '<fieldset class="kkq__group"><legend class="kkq__legend">' + esc(opt.name) + ' <b>' + esc(current.sel[i] || '') + '</b></legend><div class="kkq__values">';
        opt.values.forEach(function (val) {
          var on = current.sel[i] === val, out = !valueAvailable(i, val);
          html += '<button type="button" class="kkq__value' + (on ? ' is-on' : '') + (out ? ' is-out' : '') + '" data-kkq-opt="' + i + '" data-kkq-value="' + esc(val) + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (out ? ' aria-label="' + esc(val) + ', sold out"' : '') + '>' + esc(val) + '</button>';
        });
        html += '</div></fieldset>';
      });
    }
    if (fixed) html = '<p class="kkq__fixed">' + fixed + '</p>' + html;
    var host = q('[data-kkq-options]');
    var active = document.activeElement, fOpt = null, fVal = null;
    if (active && host.contains(active)) { fOpt = active.getAttribute('data-kkq-opt'); fVal = active.getAttribute('data-kkq-value'); }
    host.innerHTML = html;
    if (fVal != null) {
      host.querySelectorAll('[data-kkq-opt="' + fOpt + '"]').forEach(function (b) { if (b.getAttribute('data-kkq-value') === fVal) b.focus({ preventScroll: true }); });
    }
    var ok = !!(v && v.available);
    var add = q('[data-kkq-add]'), buy = q('[data-kkq-buy]');
    add.disabled = !ok; label(add, !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out'));
    if (buy) { buy.disabled = !ok; label(buy, 'Buy now'); }
  }

  function choose(i, value) {
    current.sel[i] = value;
    // if the combination is sold out, slide to an in-stock variant that keeps this choice
    var v = variantFor(current.sel);
    if (!v || !v.available) {
      var alt = current.product.variants.filter(function (x) { return x.available && x.options[i] === value; })[0];
      if (alt) { current.sel = alt.options.slice(); v = alt; }
    }
    q('[data-kkq-note]').textContent = '';
    paintForm();
    showVariantPhoto(v);
  }

  function buyNow(id) {
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new URLSearchParams({ id: String(id), quantity: '1' }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = ROOT + 'checkout'; })
      // never land on the cart page: the permalink goes straight into checkout with this item
      .catch(function () { window.location.href = ROOT + 'cart/' + id + ':1'; });
  }

  function submit(buy) {
    var v = variantFor(current.sel);
    if (!v || !v.available) return;
    var add = q('[data-kkq-add]'), buyBtn = q('[data-kkq-buy]'), note = q('[data-kkq-note]');
    var working = buy ? buyBtn : add, plus = lastFocus, mine = sheet;
    sheet.querySelector('.kkq__panel').focus({ preventScroll: true });   // keep focus in the dialog while its buttons are off
    add.disabled = true; if (buyBtn) buyBtn.disabled = true;
    working.classList.add('is-loading');
    working.setAttribute('aria-busy', 'true');
    if (buy) { buyNow(v.id); return; }
    addToCart(v.id).then(function (openCart) {
      add.classList.remove('is-loading');
      add.classList.add('is-done');
      add.removeAttribute('aria-busy');
      add.setAttribute('aria-label', 'Added to cart');
      note.textContent = '';
      markAdded(plus);
      // long enough to see the tick land, then the cart takes over
      setTimeout(function () {
        // closed since, and another panel opened: leave that one alone and only update the count
        var movedOn = sheet !== mine;
        if (movedOn) { openCart(true); return; }
        closeSheet(true);
        // the panel steps away, the card's photograph flies into the bag, then the cart opens —
        // unless another panel was opened meanwhile: then the cart is only brought up to date
        flyToBag(plus, 260).then(function () { openCart(sheet !== mine && !!sheet && sheet.classList.contains('is-open')); });
      }, reduce ? 0 : TICK_DRAW);
    }).catch(function (err) {
      if (sheet !== mine) return;                  // the panel this belonged to is gone
      paintForm();
      note.textContent = err && err.kk && err.message !== 'add_failed' ? err.message : 'Couldn’t add that just now. Please try again.';
    });
  }

  function openSheet(handle, url, opener) {
    if (sheet) sheet.remove();
    thumb = cardPhoto(opener);
    buildSheet(url);
    lastFocus = opener || document.activeElement;
    current = null;
    var turn = ++opened;                          // a slower, earlier request must never paint into this sheet
    void sheet.offsetWidth;                       // commit the closed state so the open animates
    sheet.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    sheet.querySelector('.kkq__panel').focus({ preventScroll: true });

    var ready = cache[handle] ? Promise.resolve(cache[handle]) : fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); });
    ready.then(function (p) {
      cache[handle] = p;
      if (turn !== opened || !sheet || !sheet.classList.contains('is-open')) return;
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      current = { product: p, url: url, sel: first.options.slice(), track: null, sync: null };
      paintHead();
      paintGallery();
      paintForm();
    }).catch(function () { if (turn === opened) window.location.href = url; });
  }

  function closeSheet(keepFocus) {
    if (!sheet) return;
    opened++;
    sheet.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- + on a card ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.kks__add');
    if (!t) return;
    var direct = t.getAttribute('data-kks-add');
    var handle = t.getAttribute('data-kks-quick');
    if (!direct && !handle) return;          // plain link: let it navigate
    e.preventDefault();
    e.stopPropagation();
    var url = t.getAttribute('data-kks-url') || t.getAttribute('href') || ROOT;
    if (direct) {
      if (t.classList.contains('is-busy') || t.classList.contains('is-done')) return;
      t.classList.add('is-busy');
      addToCart(direct).then(function (openCart) {
        markAdded(t);
        // the tick draws while the photograph flies into the bag; the cart opens as it lands
        flyToBag(t, TICK_DRAW).then(function () { openCart(); });
      }).catch(function () { t.classList.remove('is-busy'); window.location.href = url; });
    } else {
      openSheet(handle, url, t);
    }
  });

  function scan() {
    document.querySelectorAll('.kkm').forEach(watch);
    document.querySelectorAll('[data-kks]').forEach(initSlider);
  }

  window.__kkHome = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);

  // If anything keeps the observer from firing, nothing stays invisible.
  function revealOnScreen() {
    document.querySelectorAll('.kkm:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) reveal(el);
    });
  }
  setTimeout(revealOnScreen, 2500);

  // The page can run out before a section reaches its depth (a short page, a last section):
  // once the end of the document is on screen, whatever is in view reveals.
  function watchEnd() {
    if (designMode || !('IntersectionObserver' in window) || !document.body) return;
    var end = document.createElement('span');
    end.setAttribute('aria-hidden', 'true');
    end.style.cssText = 'display:block;height:1px;margin-top:-1px;pointer-events:none;';
    document.body.appendChild(end);
    new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) revealOnScreen();
    }).observe(end);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchEnd);
  else watchEnd();
})();
